// extracted by mini-css-extract-plugin
export default {"title":"Steps_title__ZxBAu","subtitle":"Steps_subtitle__9Auch"};